// @react/hooks/useProjectLabel.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { projectLabelStore } from '@core/stores';

/**
 * React hook for ProjectLabel operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useProjectLabel } from '@react/hooks';
 *
 * const ProjectLabelList = observer(() => {
 *   const store = useProjectLabel();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useProjectLabel() {
  return projectLabelStore;
}
